import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { bootSentry } from './sentry'
import './assets/main.css'
import './lib/catalog' // Import catalog functions for tests

const app = createApp(App)
app.use(router)
void bootSentry(app, router)
app.mount('#app')
